module.exports = __webpack_public_path__ + "img/MS-J-13.25f1fb89.svg";